export default {
  methods: {
    selectNextShape (e) {
      let shapesLayer = this.stage.find('#shape')[0]
      let selectedShape = shapesLayer.children.filter(function (el) {
        return el.attrs.selected === true
      })

      if (selectedShape.length > 0) {
        let index = shapesLayer.children.indexOf(selectedShape[0])
        let newShape = shapesLayer.children[index + 1] || shapesLayer.children[0]

        this.clearSelection()
        this.canDelete = true
        this.focusedElement = newShape.attrs.id
        this.highlightShape = newShape
        this.highlightSelection(newShape)
        window.scrollTo(0, newShape.getY())
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/utils.js